import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        learndashCourses: '=',
        scormCourses: '<',
        context: '=',
        forms: '=',
        surveyForms: '=',
        feedbackForms: '=',
        canManageCourse: '=',
        courseVersion: '=',
        course: '=',
        company: '=',
        loaded: '=',
        activeTab: '<',
        settings: '<'
    },
    template: `
    <div ng-if="vm.loaded || !vm.form.model.courseTrainings.length">
        <div class="alert alert-warn" ng-if="!vm.courseVersion.isArchived
            && (vm.errors.length || vm.occurrenceMessage || (vm.hasPlanningGroups && !vm.hasPublishedOccurrence))">
            <ul>
                <li ng-if="vm.occurrenceMessage">{{ vm.occurrenceMessage }}</li>
                <li ng-if="vm.hasPlanningGroups && !vm.hasPublishedOccurrence">{{ 'version.alias.related_planning_groups' | translate:{count: vm.hasPlanningGroups} }}</li>
                <li ng-repeat="error in vm.errors track by $index + error">{{ error }}</li>
            </ul>
        </div>
        <div class="alert alert-plain" ng-if="vm.courseVersion.isArchived">
            <p>{{ 'version.This version has been archived' | translate }}</p>
        </div>
        <ul class="tabs01">
            <li ng-repeat="tab in vm.settings.tabs" ng-if="tab.isEnabled">
                <span ng-click="vm.tab=tab.id"
                    ng-class="{ active: vm.tab === tab.id || vm.activeTab === tab.id }">
                    {{ tab.title }}
                </span>
            </li>
        </ul>
        <div class="well type02">
            <div ng-style="{'display' : vm.tab === 'settings' ? 'block' : 'none'}">
                <courses-courses-steps-version-version
                    course-version="vm.courseVersion"
                    form="vm.form"
                    can-manage-course="vm.canManageCourse"
                    context="vm.context"
                    is-study-material-public="vm.isStudyMaterialPublic"
                />
            </div>
            <div ng-if="vm.isLicensePointsEnabled" ng-style="{'display' : vm.tab === 'licence' ? 'block' : 'none'}">
                <courses-courses-steps-version-licence
                    course="vm.course"
                    form="vm.form"
                    can-manage-course="vm.canManageCourse"
                    context="vm.context"
                    on-register="vm.setVersionLicenceComponent($ctrl)"
                />
            </div>
            <div ng-if="vm.TokenService.isSkillsModuleEnabled() && vm.PrivilegeService.canManageSkills()" ng-style="{'display' : vm.tab === 'skills' ? 'block' : 'none'}">
                <courses-courses-steps-version-skills
                    course="vm.course"
                    form="vm.form"
                    can-manage-course="vm.canManageCourse"
                    context="vm.context"
                />
            </div>
            <div class="center" ng-style="{'display' : vm.tab === 'activities' ? 'block' : 'none'}" ng-if="!vm.form.model.courseTrainings.length">
                <h2>{{ 'general.There\\'s nothing here yet' | translate }}</h2>
                <p>{{ 'version.Select an option below to get started' | translate }}</p>
                <ul class="actions02">
                    <li>
                        <button class="actions02__item" ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE)">
                            <span class="inner ico-elearning">
                                <span class="title">{{ 'version.Online content' | translate }}</span>
                                <span>{{ 'version.Create online content' | translate }}</span>
                            </span>
                        </button>
                    </li>
                    <li ng-if="!vm.course.isGuidance">
                        <button class="actions02__item" ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM)">
                            <span class="inner ico-instructor">
                                <span class="title">{{ 'version.Instructor-led training' | translate }}</span>
                                <span>{{ 'version.Organize physical on site training sessions' | translate }}</span>
                            </span>
                        </button>
                    </li>
                    <li ng-if="vm.TokenService.isFormModuleEnabled() && !vm.course.isGuidance">
                        <button class="actions02__item" ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST)">
                            <span class="inner ico-assessment">
                                <span class="title">{{ 'course.trainingType.Test' | translate }}</span>
                                <span>{{ 'version.Add evaluation activities to assess learning outcomes' | translate }}</span>
                            </span>
                        </button>
                    </li>
                    <li ng-if="vm.TokenService.isFormSurveyModuleEnabled()">
                        <button class="actions02__item" ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK)">
                            <span class="inner ico-feedback">
                                <span class="title">{{ 'course.trainingType.Feedback' | translate }}</span>
                                <span>{{ 'version.Ask feedback to improve training quality and learner experience' | translate }}</span>
                            </span>
                        </button>
                    </li>
                </ul>
            </div>
            <div ng-style="{'display' : vm.tab === 'activities' ? 'block' : 'none'}" ng-if="vm.form.model.courseTrainings.length">
                <div class="colholder mt1em">
                    <div class="col col09 pt0" >
                        <ul dnd-list="vm.form.model.courseTrainings" class="toc-menu01" style="padding:0px;">
                            <li ng-repeat="(key, item) in vm.form.model.courseTrainings"
                                dnd-draggable="item"
                                dnd-disable-if="!vm.canManageCourse
                                || (vm.hasPublishedOccurrence && vm.isFixedTraining())
                                || vm.errors.length"
                                dnd-moved="vm.form.model.courseTrainings.splice($index, 1)"
                                ng-click="vm.clickTraining($index)"
                                ng-class="{'active': vm.selectedTraining == $index}"
                                dnd-effect-allowed="move"
                                class="item"
                            >
                            	<img class="item-icon" ng-if="item.status=='warn'" alt="Needs attention" src="assets/css/icon_warn.svg"/>
					            <img class="item-icon" ng-if="item.status=='error'" alt="Needs attention" src="assets/css/icon_error.svg"/>
                                <div class="item-heading">
                                    <a class="item-title active">
                                        {{item.label}}<br>
                                        <span class="item-meta">{{item.activityType}}</span>
                                    </a>
                                    <div class="action-menu" ng-if="vm.disabledTrainings.includes($index) === false && vm.canManageCourse && !vm.hasPublishedOccurrence && !vm.hasPlanningGroups">
                                        <button aria-haspopup="true" aria-expanded="{{item.menuOpen}}"
                                            ng-click="item.menuOpen=!item.menuOpen;vm.actions=false;vm.handleTrainingMenu($index);$event.stopPropagation()"><span>&nbsp;</span></button>
                                        <ul role="menu">
                                            <li ng-if="!vm.hasPublishedOccurrence && !vm.hasPlanningGroups">
                                                <a ng-click="vm.delete($index)">{{ 'general.Delete' | translate }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="action-menu" ng-if="vm.canManageCourse && !vm.hasPublishedOccurrence && !vm.hasPlanningGroups">
                            <button
                                ng-disabled="vm.disabledTrainings.length"
                                aria-haspopup="true"
                                class="visible-label btn bordered02"
                                ng-class="{'ico-arrow-up02': vm.actions==true,'ico-arrow-down03': vm.actions==false}"
                                aria-expanded="{{vm.actions}}" ng-click="vm.actions=!vm.actions;vm.closeMenuItems()">{{ 'version.Add activity' | translate }}</button>
                            <ul role="menu">
                                <li><a ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE); vm.actions=false;">{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS.ONLINE | translate }}</a></li>
                                <li
                                    ng-if="vm.TokenService.isWebinarModuleEnabled() && !vm.course.isGuidance"
                                ><a ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR); vm.actions=false;">{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS.WEBINAR | translate }}</a></li>
                                <li
                                    ng-if="!vm.course.isGuidance"
                                ><a ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM); vm.actions=false;">{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS.CLASSROOM | translate }}</a></li>
                                <li
                                    ng-if="vm.TokenService.isFormModuleEnabled() && !vm.course.isGuidance"
                                ><a ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST); vm.actions=false;">{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS.TEST | translate }}</a></li>
                                <li
                                    ng-if="vm.TokenService.isFormSurveyModuleEnabled()"
                                ><a ng-click="vm.clone(vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK); vm.actions=false;">{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS.FEEDBACK | translate }}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col col05 pt0 ng-scope">
                        <div ng-if="vm.loaded">
                            <div class="ng-scope" ng-repeat="(key, trainingForm) in vm.form.model.courseTrainings">
                                <div class="form" ng-if="key==vm.selectedTraining">
                                    <form-row-wide error="vm.form.errors.courseTrainings[key].courseTrainingI18ns[vm.defaultLanguage].name">
                                        <span class="row row-wide" ng-class="{ 'has-error': vm.form.errors.courseTrainings[key].courseTrainingI18ns[vm.defaultLanguage].name }">
                                            <label class="label w100p">{{ 'course.Name' | translate }} *</label>
                                            <div class="items w100p">
                                                <input type="text" class="form-control" ng-model="trainingForm.courseTrainingI18ns[vm.defaultLanguage].name">
                                                <form-row-wide-error></form-row-error>
                                            </div>
                                        </span>
                                    </form-row-wide>
                                    <div class="ng-scope">
                                        <courses-courses-steps-version-training-online
                                            ng-if="trainingForm.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE"
                                            form="vm.form"
                                            course="vm.course"
                                            scorm-courses="vm.scormCourses"
                                            context="vm.context"
                                            forms="vm.forms"
                                            company="vm.company"
                                            can-manage-course="vm.canManageCourse"
                                            training-form="trainingForm"
                                            key="key"
                                            is-disabled="vm.isDisabled"
                                            training-types="vm.trainingTypes"
                                            has-planning-groups="vm.hasPlanningGroups"
                                            ckconfig="vm.ckconfig"
                                            save="vm.save()"
                                        />
                                        <courses-courses-steps-version-training-test
                                            ng-if="trainingForm.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST"
                                            form="vm.form"
                                            context="vm.context"
                                            can-manage-course="vm.canManageCourse"
                                            training-form="trainingForm"
                                            key="key"
                                            is-disabled="vm.isDisabled"
                                            training-types="vm.trainingTypes"
                                            has-planning-groups="vm.hasPlanningGroups"
                                            ckconfig="vm.ckconfig"
                                            has-published-occurrence="vm.hasPublishedOccurrence"
                                            form-copy="vm.formCopy"
                                            forms="vm.forms"
                                            feedback-forms="vm.feedbackForms"
                                        />
                                        <courses-courses-steps-version-training-feedback
                                            ng-if="trainingForm.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK"
                                            form="vm.form"
                                            context="vm.context"
                                            can-manage-course="vm.canManageCourse"
                                            training-form="trainingForm"
                                            key="key"
                                            is-disabled="vm.isDisabled"
                                            training-types="vm.trainingTypes"
                                            has-planning-groups="vm.hasPlanningGroups"
                                            ckconfig="vm.ckconfig"
                                            survey-forms="vm.surveyForms"
                                        />
                                    </div>
                                    <div class="block02 type02" ng-class="{ open: vm.showAdditionalSettings===true }">
                                        <div class="heading01 theme01">
                                            <h3 ng-click="vm.showAdditionalSettings=!vm.showAdditionalSettings">{{ 'general.Additional settings' | translate }}</h3>
                                        </div>
                                        <div class="block02b ng-scope fade" ng-show="vm.showAdditionalSettings === true">
                                            <courses-courses-steps-version-training-additional
                                                form="vm.form"
                                                can-manage-course="vm.canManageCourse"
                                                training-form="trainingForm"
                                                key="key"
                                                is-disabled="vm.isDisabled"
                                                training-types="vm.trainingTypes"
                                                ckconfig="vm.ckconfig"
                                            />
                                            <courses-courses-steps-version-training-additional-webinar
                                                ng-if="trainingForm.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR"
                                                form="vm.form"
                                                can-manage-course="vm.canManageCourse"
                                                training-form="trainingForm"
                                                key="key"
                                                is-disabled="vm.isDisabled"
                                                training-types="vm.trainingTypes"
                                                ckconfig="vm.ckconfig"
                                                course="vm.course"
                                            />
                                            <courses-courses-steps-version-training-additional-classroom
                                                ng-if="trainingForm.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM"
                                                form="vm.form"
                                                can-manage-course="vm.canManageCourse"
                                                training-form="trainingForm"
                                                key="key"
                                                is-disabled="vm.isDisabled"
                                                training-types="vm.trainingTypes"
                                                ckconfig="vm.ckconfig"
                                                course="vm.course"
                                            />
                                            <courses-courses-steps-version-training-additional-test
                                                ng-if="trainingForm.type === vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST"
                                                form="vm.form"
                                                training-form="trainingForm"
                                                key="key"
                                                is-disabled="vm.isDisabled"
                                                forms="vm.forms"
                                                feedback-forms="vm.feedbackForms"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <style>
        .form-control {
        outline: none;
        display: block; /* Make it full-width */
        width: 100%; /* Full length */
        vertical-align: middle;
        box-sizing: border-box;
        position: relative;
        z-index: 0;
        padding: 12px 16px; /* Increased padding for better spacing */
        line-height: 1.5;
        height: auto; /* Allow height to adjust based on content */
        border: 2px solid #e0e0e0; /* Softer border color */
        border-radius: 8px; /* Slightly rounded corners */
        background: #ffffff; /* White background */
        font-size: 14px; /* Consistent font size */
        color: #333333; /* Darker text for better readability */
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* Subtle shadow for depth */
        transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transitions */
        font-family: 'Arial', sans-serif; /* Match the font with the design */
      }

      .form-control:focus {
        border-color: #007bff; /* Highlight color when focused */
        box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2); /* Enhanced shadow on focus */
      }
    </style>
    `
})

export default class {
    constructor ($translate, $state, $window, $scope, lodash, Upload, CourseVersionResource, CkEditorService, $rootScope, toastr, $document, $timeout,
                 ModalService, TokenService, PrivilegeService, CourseVersionService, ResponseService, CourseVersionTrainingFormLearndashService, LearndashResource,
                 COURSE_TRAINING_ORDER_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM, COURSE_TRAINING_MATERIAL_TYPE_ENUM, COURSE_TRAINING_PASSING_TYPE_ENUM) {
        this.$translate = $translate;
        this.$state = $state;
        this.$window = $window;
        this.toastr = toastr;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.lodash = lodash;
        this.Upload = Upload;
        this.CourseVersionResource = CourseVersionResource;
        this.CkEditorService = CkEditorService;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.PrivilegeService = PrivilegeService;
        this.CourseVersionService = CourseVersionService;
        this.ResponseService = ResponseService;
        this.CourseVersionTrainingFormLearndashService = CourseVersionTrainingFormLearndashService;
        this.LearndashResource = LearndashResource;
        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;

        this.isLicensePointsEnabled = this.TokenService.isLicencePointsModuleEnabled();

        this.tab = this.activeTab || 'activities';
        this.actions = false;

        this.errors = [];
        // in case we have error we should disable all other trainings without errors
        this.disabledTrainings = [];

        if (!this.form.model.courseTrainings) {
            this.form.model.courseTrainings = [];
        }

        $scope.$watch('vm.learndashCourses', () => {
            this.setLdCourses();
        });

        $scope.$on('course:save', (event, data) => {
            this.save(data.redirect);
        });

        $scope.$watch('vm.selectedTraining', (newValue) => {
            $rootScope.$broadcast('versionActions:setSelectedCourseTrainingIndex', {
                selectedCourseTrainingIndex: newValue
            });
        });

        $scope.$watch('vm.form.model', (newValue) => {
            $rootScope.$broadcast('versionActions:setCourseVersion', {
                courseVersion: newValue
            });
        }, true);

        const listener = $rootScope.$on('version:reload', (event, version) => {
            this.form.model.isArchived = version.isArchived;
        });
        $scope.$on('$destroy', listener);

        this.isStudyMaterialPublic = this.form.model.isStudyMaterialPublic ? '1' : '0';

        const documentClickHandler = (event) => {
            const isClickedInsideMenu = event.target.closest('.action-menu button');
            if (!isClickedInsideMenu) {
                this.actions = false;
                this.closeOpenedMenus();
                $rootScope.$apply();
            }
        };
        $document.on('click', documentClickHandler);
    }
    $onInit () {
        const { lodash, form } = this;
        this.occurrenceMessage = this.CourseVersionService.getWarningMessage(this.courseVersion);
        this.hasPublishedOccurrence = this.CourseVersionService.getPublishedOccurrenceCount(form.model);
        this.unPublishedOccurrenceCount = this.CourseVersionService.getUnpublishedCancelledOccurrenceCount(form.model);
        this.hasPlanningGroups = this.form.model.automatedPlanningGroups.length;
        this.isDisabled = !this.canManageCourse || this.hasPublishedOccurrence !== 0;

        this.deletedTraining = [];

        this.deletedTrainingIndex = null;
        // duplicate form name to .name property because tags-input can't access nested object property
        lodash.forEach(this.forms, item => {
            item.name = lodash.get(item, 'activeI18n.name', '-');
        });

        // init default language for correct validation
        lodash.forEach(form.model.courseTrainings, (training) => {
            // add activityType
            training.activityType = this.COURSE_TRAINING_TYPE_ENUM.LABELS[training.type];
            // if default language is not set, set it for correct validation
            if (!lodash.has(training.courseTrainingI18ns, this.defaultLanguage)) {
                lodash.set(training, `courseTrainingI18ns.${this.defaultLanguage}.name`, '');
            }
            // merge additional property for draggable listing label
            lodash.assign(training, { label: training.courseTrainingI18ns[this.defaultLanguage].name });


            // if training has courseTrainingForms set correct property for tags-input
            if (training.courseTrainingForms) {
                training.forms = [];
                lodash.forEach(training.courseTrainingForms, trainingForm => {
                    const item = lodash.find(this.forms, { id: trainingForm.formId });
                    training.forms.push(item);
                });
            }
            this.getLearndashCourse(training);
        });

        if (this.tab === undefined) {
            this.tab = this.activeTab || 'activities';
        }
        if (this.selectedTraining === undefined) {
            this.selectedTraining = 0;
        }

        // auto-clone only if there are no trainings yet
        // if (!form.model.courseTrainings || form.model.courseTrainings.length === 0) {
        //    this.clone(this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE);
        // }

        this.trainingTypes = this.COURSE_TRAINING_TYPE_ENUM.KEYS;

        if (!this.TokenService.isFormSurveyModuleEnabled()) {
            delete this.trainingTypes[this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK];
        }

        if (!this.TokenService.isFormModuleEnabled()) {
            delete this.trainingTypes[this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST];
        }

        if (!this.TokenService.isWebinarModuleEnabled()) {
            delete this.trainingTypes[this.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR];
        }

        this.formCopy = angular.copy(this.form);

        this.ckconfig = this.CkEditorService.getDefaultConfig();
        this.ckconfig.readOnly = !this.canManageCourse;

        this.displayRequiredFieldWarnings();
    }

    clickTraining (index) {
        if (this.disabledTrainings.includes(index) === false) {
            this.selectedTraining = index;
        }
    }

    setVersionLicenceComponent (ctrl) {
        this.versionLicenceComponent = ctrl;
    }

    closeMenuItems () {
        this.lodash.forEach(this.form.model.courseTrainings, courseTraining => {
            courseTraining.menuOpen = false;
        });
    }

    isFixedTraining () {
        return this.form.model.trainingOrderType === this.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.SEQUENCE;
    }

    closeOpenedMenus () {
        this.lodash.forEach(this.form.model.courseTrainings, courseTraining => {
            courseTraining.menuOpen = false;
        });
    }

    handleTrainingMenu (index) {
        this.lodash.forEach(this.form.model.courseTrainings, (courseTraining, key) => {
            if (index !== key) {
                courseTraining.menuOpen = false;
            }
        });
    }

    setLdCourses () {
        this.CourseVersionTrainingFormLearndashService.setLdCourses(this.learndashCourses);
    }

    isCourseWithMaterials () {
        const isCourseWithMaterials = this.form.model.courseTrainings.some(training => {
            return training.type !== this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST;
        });

        if (!isCourseWithMaterials) {
            this.form.model.isStudyMaterialPublic = false;
        }

        return isCourseWithMaterials;
    }

    hasError (index) {
        return this.lodash.has(this.form.errors, `courseTrainings.${index}`)
            && this.form.errors.courseTrainings !== undefined
            && !this.lodash.isEmpty(this.form.errors.courseTrainings[index]);
    }

    clone (trainingType) {
        this.form.errors = {};
        const label = this.$translate.instant('courses.New Training');

        const training = {
            label, // used for draggable list display
            type: trainingType,
            materialType: trainingType === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
                ? this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_CONTENT
                : null,
            passingType: trainingType === this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK
                ? this.COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS.OPTIONAL
                : this.COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS.MANDATORY,
            learndashCourseId: 0,
            activityType: this.COURSE_TRAINING_TYPE_ENUM.LABELS[trainingType]
        };
        this.lodash.set(training, `courseTrainingI18ns.${this.defaultLanguage}`, {
            name: label,
            description: ''
        });
        this.form.model.courseTrainings.push(training);
        this.selectedTraining = this.form.model.courseTrainings.length - 1;

        this.save(false, false, false);
    }

    delete (index) {
        return this.ModalService.delete().then(() => {
            this.form.model.courseTrainings.splice(index, 1);
            if (this.selectedTraining === index) {
                if (index > 0) {
                    this.selectedTraining = index - 1;
                }
                else {
                    this.selectedTraining = 0;
                }
            }
            this.save(false, false, false);
        });
    }

    beforeSave () {
        this.form.cleanErrors();
        this.form.model.isStudyMaterialPublic = this.isStudyMaterialPublic;
        this.CourseVersionService.mapTrainingForms(this.form.model.courseTrainings);
    }

    isScormFileChanged () {
        if (this.hasPublishedOccurrence !== 0) {
            this.scormFileChanged = false;
            this.lodash.forEach(this.form.model.courseTrainings, courseTraining => {
                if (courseTraining.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE) {
                    this.lodash.forEach(courseTraining.scormTrainings, scormTraining => {
                        if (scormTraining.scorm !== undefined && scormTraining.scormFileName !== undefined && scormTraining.scormFileName !== scormTraining.scorm.name) {
                            this.scormFileChanged = true;
                        }
                    });
                }
            });
        }
        return this.scormFileChanged;
    }

    save (redirectAfterSave, showConfirmation = true, showToastr = true) {
        this.beforeSave();

        const learndashCourseAllowedTypes = [
            this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM,
            this.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR,
            this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
        ];
        this.lodash.forEach(this.form.model.courseTrainings, courseTraining => {
            if (!this.lodash.includes(learndashCourseAllowedTypes, courseTraining.type) && courseTraining.learndashCourseId) {
                courseTraining.learndashCourseId = null;
            }
        });

        const confirmMessages = [];
        const onlineTrainings = this.CourseVersionService.getOnlineTrainingsWoMaterials(
            this.form.model.courseTrainings
        );

        if (onlineTrainings.length) {
            const trainingNames = onlineTrainings.map((training) => training.courseTrainingI18ns[this.defaultLanguage].name).join(', ');
            confirmMessages.push(this.$translate.instant(
                'version.alias.online_trainings_wo_materials', { trainingNames }
            ));
        }

        if (this.unPublishedOccurrenceCount && !this.hasPublishedOccurrence) {
            const messages = [];
            messages.push(this.$translate.instant('version.alias.unpublished_occurrences', { count: this.unPublishedOccurrenceCount }));
            messages.push(this.$translate.instant('general.Are you sure you want to save changes?'));
            confirmMessages.push(messages.join('<br>'));
        }
        else if (this.context === 'add' && this.form.model.isWithoutPlanning && showConfirmation) {
            const userCount = this.CourseVersionService.getWithoutPlanningUserCount(this.form.model);
            confirmMessages.push(this.$translate.instant(
                'version.Without planning confirm message', { count: userCount }
            ));
        }

        if (!this.CourseVersionService.hasRequiredTrainings(this.form.model.courseTrainings) && this.form.model.courseTrainings.length) {
            confirmMessages.push(this.$translate.instant('version.only_online_trainings_message_version'));
        }

        if (this.hasPublishedOccurrence !== 0 && this.isScormFileChanged()) {
            confirmMessages.push(this.$translate.instant(
                'course.scorm.If any employee has the training in progress, then changing the file will reset the progress. Are you sure you wish to continue?'
            ));
        }

        if (confirmMessages.length) {
            this.ModalService.confirm(confirmMessages, 'medium')
                .then(() => this.doSave(redirectAfterSave, showToastr))
                .catch(() => {
                    this.selectedTraining = 0;
                })
            ;
        }
        else {
            this.doSave(redirectAfterSave, showToastr);
        }
    }

    doSave (redirectAfterSave, showToastr) {
        this.errors = [];
        this.disabledTrainings = [];

        let uploadUrl = `${SEED_CORE.ENV.API_URL}course/version`;
        let method = 'POST';

        this.loading = true;
        this.$rootScope.$broadcast('courseVersion:loading', { loading: this.loading });

        if (this.form.model.id) {
            delete this.form.model.$promise;
            delete this.form.model.$resolved;
            uploadUrl += `/${this.form.model.id}`;
            method = 'PUT';
        }

        if (this.form.model.courseTrainings.length === 0) {
            this.form.model.deleteAllCourseTrainings = true;
        }

        uploadUrl += '?expand=courseTrainings,courseTrainings.scormTrainings.scorm,courseTrainingI18ns,courseOccurrences,creator,updater,courseTrainingForms,courseVersionLicences' +
            ',automatedPlanningGroups,courseTrainings.materials,courseTrainings.materials.languages' +
            ',courseTrainings.materials.chapters.chapterI18ns,courseTrainings.materials.chapters.section.sectionI18ns,activeCourseSkills';
        return this.Upload.upload({
            url: uploadUrl,
            method,
            data: this.form.model
        }).then((response) => {
            if (showToastr) {
                this.toastr.success(this.$translate.instant('general.Changes saved'));
            }
            this.handleSuccess(response, redirectAfterSave);
            if (this.form.model.isTrainingDelete) {
                this.handleTrainingDeleteSuccess();
            }

            // handle fields that needs to be filled
            this.displayRequiredFieldWarnings();
        }).catch((response) => {
            this.resetErrors();
            this.settings = true;
            this.toastr.error(this.$translate.instant('general.There were errors processing the form'));
            this.handleFormErrors(response);

            this.form.invalid = true;
            this.form.saved = false;
            this.form.errors = this.ResponseService.parseErrors(response);

            // set tab with errors
            if (this.form.errors.name) {
                this.tab = 'settings';
            }

            if (this.$window.document.scrollingElement) {
                this.$window.document.scrollingElement.scrollTop = 0;
            }
            if (this.form.model.isTrainingDelete) {
                this.handleTrainingDeleteError();
            }
        }).finally(() => {
            // Add a small delay before setting loading to false to ensure Safari has time to process UI updates
            this.$timeout(() => {
                this.loading = false;
                this.$rootScope.$broadcast('courseVersion:loading', { loading: this.loading });
            });
        });
    }

    resetErrors () {
        this.lodash.forEach(this.form.model.courseTrainings, (training) => {
            training.status = null;
        });
    }

    handleFormErrors (response) {
        this.lodash.forEach(this.form.model.courseTrainings, (training, trainingIndex) => {
            this.disabledTrainings.push(trainingIndex);
        });
        response.data.forEach((error) => {
            if (error.path !== undefined) {
                const match = error.path.match(/courseTrainings\.(\d+)/);
                if (match) {
                    const index = parseInt(match[1], 10);
                    if (this.form.model.courseTrainings[index]) {
                        this.selectedTraining = index;
                        this.form.model.courseTrainings[index].status = 'error';
                        // remove this item from disabledTrainings
                        this.disabledTrainings = this.disabledTrainings.filter(item => item !== index);
                    }
                }
            }
            this.errors.push(error.message);
        });
    }

    displayRequiredFieldWarnings () {
        this.form.warnings = {};
        this.lodash.forEach(this.form.model.courseTrainings, (training, index) => {
            if (training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST) {
                if (!training.formId && !training.isFormRandomized) {
                    training.status = 'warn';
                    this.initFormWarinings(index);
                    this.form.warnings.courseTrainings[index].formId = this.$translate.instant('authoringTool.Form is mandatory');
                }
            }
            if (training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
                    && training.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_CONTENT
            ) {
                if (!training.materials.length) {
                    training.status = 'warn';
                    this.initFormWarinings(index);
                    this.form.warnings.courseTrainings[index].materials = this.$translate.instant('authoringTool.Training material is mandatory');
                }
            }
            if (training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK) {
                if (!training.formId) {
                    training.status = 'warn';
                    this.initFormWarinings(index);
                    this.form.warnings.courseTrainings[index].formId = this.$translate.instant('authoringTool.Form is mandatory');
                }
                if (!training.courseTrainingI18ns[this.defaultLanguage].feedbackTitle) {
                    training.status = 'warn';
                    this.initFormWarinings(index);
                    this.form.warnings.courseTrainings[index].feedbackTitle = this.$translate.instant('authoringTool.Feedback title is mandatory');
                }
            }
        });
    }

    initFormWarinings (index) {
        if (this.form.warnings.courseTrainings === undefined) {
            this.form.warnings.courseTrainings = [];
        }
        if (this.form.warnings.courseTrainings[index] === undefined) {
            this.form.warnings.courseTrainings[index] = {};
        }
    }

    handleTrainingDeleteSuccess () {
        // catch saving validation error for courseTraining to prevent training from disappear
        if (this.form.errors.courseTrainings) {
            this.form.model.isTrainingDelete = false;
            this.form.model.courseTrainings[this.deletedTrainingIndex] = this.deletedTraining[0];
        }
    }

    handleTrainingDeleteError () {
        this.form.model.isTrainingDelete = false;
        // because splice returns array, get first element and set it back to form
        this.form.model.courseTrainings[this.deletedTrainingIndex] = this.deletedTraining[0];
    }

    handleSuccess (response, redirect) {
        this.form.errors = {};
        this.form.saved = true;
        this.form.invalid = false;

        if (redirect) {
            // logic for transision is removed currently according to the new requirements
        }

        const version = new this.CourseVersionResource(response.data);
        this.CourseVersionService.nestCompositeModels(version);
        this.form.model = version;

        this.$onInit();
        if (this.TokenService.isLicencePointsModuleEnabled()) {
            this.versionLicenceComponent.$onInit();
        }
        this.$scope.$emit('version:reload', version);
    }

    getLearndashCourse (training) {
        this.showLearndashCourseEditLink = false;
        training.canEditLearndashCourse = false;
        if (training.learndashCourseId) {
            this.LearndashResource.getCourse({
                id: training.learndashCourseId,
                _lang: this.TokenService.getCompanyLanguage(true)
            }).$promise.then(result => {
                training.canEditLearndashCourse = result.isEditable;
                this.showLearndashCourseEditLink = result.isEditable;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/index.js